import { Box, Typography } from '@mui/material';

import { AvoidPageBreakInsideWrapper, DealBuilderHeader } from '@styles/StyledDiv';

import { SectionTitle } from '@shared/components/SectionTitle';
import { BorderWrapper } from '@styles/CommonStyles';
import { ICreditReportMessageProps } from './interfaces/interfaces';

export const CreditReportMessages = ({ creditReportMessages }: ICreditReportMessageProps) => (
  <AvoidPageBreakInsideWrapper>
    <Box marginBottom={2}>
      <SectionTitle
        title="Credit Report Messages"
        fontWeight={600}
      />

      <BorderWrapper padding="10px">
        <Box>
          {creditReportMessages &&
            (creditReportMessages.length > 0
              ? creditReportMessages?.map((creditReportMessage, index) => {
                  return (
                    <Box key={index}>
                      <DealBuilderHeader>
                        <Typography>Reported Date</Typography>
                        <Box style={{ width: '80%' }}>{creditReportMessage?.reportedDate ?? ''}</Box>
                      </DealBuilderHeader>
                      <DealBuilderHeader>
                        <Typography style={{ verticalAlign: 'top', alignItems: 'flex-start' }}>Messages</Typography>
                        <Box style={{ width: '80%' }}>{creditReportMessage?.message}</Box>
                      </DealBuilderHeader>
                    </Box>
                  );
                })
              : 'No Records found')}
        </Box>
      </BorderWrapper>
    </Box>
  </AvoidPageBreakInsideWrapper>
);
